/**
 * Horizontal left offset within a collapsed month section.
 * Odd days align to their column; even days interpolate between surrounding odd columns.
 */
export function getCollapsedDayLeftPx(
  actualDay: number,
  visibleOddDays: number[],
  dayWidthPx: number,
  paddingPx: number
): number {
  const columnIndex = visibleOddDays.indexOf(actualDay);
  if (columnIndex >= 0) {
    return columnIndex * dayWidthPx + paddingPx;
  }

  const prevOdd = [...visibleOddDays].reverse().find(day => day < actualDay);
  const nextOdd = visibleOddDays.find(day => day > actualDay);

  if (prevOdd !== undefined && nextOdd !== undefined) {
    const prevLeft = visibleOddDays.indexOf(prevOdd) * dayWidthPx + paddingPx;
    const nextLeft = visibleOddDays.indexOf(nextOdd) * dayWidthPx + paddingPx;
    return (prevLeft + nextLeft) / 2;
  }

  if (prevOdd !== undefined) {
    const prevLeft = visibleOddDays.indexOf(prevOdd) * dayWidthPx + paddingPx;
    return prevLeft + dayWidthPx / 2;
  }

  if (nextOdd !== undefined) {
    const nextLeft = visibleOddDays.indexOf(nextOdd) * dayWidthPx + paddingPx;
    return Math.max(paddingPx, nextLeft - dayWidthPx / 2);
  }

  return paddingPx;
}
